// Configuration
 config = {
    signTypes: {
        acrylic_lightbox: {
            label: 'Acrylic Lightbox',
            pruducturl: '',
            processedurl: '',
            basePrices: {},
            previews: [],
            thumbs: [
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/acrylic1.png?v=1747391967",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/acrylic2.png?v=1747391967",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/acrylic3.png?v=1747391967",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/acrylic4.png?v=1747391967"
            ]
        },
        metal_sign: {
            label: '3D Metal Sign',
            pruducturl: '',
            processedurl: '',
            basePrices: {},
            previews: [],
            thumbs: [
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/metal1.png?v=1747392318",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/metal3_ce97f831-094e-455e-848c-9208e4059b2d.png?v=1747659622",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/metal3.png?v=1747392318",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/metal4.png?v=1747392318"
            ]
        },
        acrylic_backlit: {
            label: '3D Acrylic Backlit',
            pruducturl: '',
            processedurl: '',
            basePrices: {},
            previews: [],
            thumbs: [
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/backlit1.png?v=1747392400",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/backlit2_1eee243d-595b-421e-a340-32dd36c79d47.png?v=1747726938",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/backlit3.png?v=1747392400",
                  "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/backlit4.png?v=1747392400"
            ]
        }
    },
    loadingMessages: [
        "Analyzing your logo for optimal display...",
        "Preparing premium material previews for your brand...",
        "Configuring 3D visualization settings...",
        "Setting up lighting and shadow effects...",
        "Optimizing your design for different sign types...",
        "Almost ready to transform your brand into stunning signage!"
    ]
};

 const mockupApiURL = 'https://designs.quicksignage.com'; 
   var productURL;
//------------------------------------
  async function submitForm() {
    
          try {
              let fileInput = document.getElementById('file-input');
              let imageFile = fileInput.files[0];
              let clientName = document.getElementById('customer-name').value;
              let customerNameError = document.getElementById('customername-error');
              // let mockupApiURL = 'https://designs.quicksignage.com';
              // let loaderbox = document.getElementById('loaderbox');
              // let progress = document.getElementById('progress');
              // let statustext = document.getElementById('status-text');
              // let mucimg = document.getElementById("ah-muc");
              // let mockupResult = document.getElementById('mockupResult');
              // let ratingContent = document.getElementById('rating-content');
              let formData = new FormData();
              formData.append('image', imageFile);
              formData.append('name', clientName); 
              formData.append('template', 1);
              console.log("submit form function is running...");
              
              simulateUploadProgress();
              const response = await fetch(`${mockupApiURL}/api/webhook/generate/mockup/job/bulk`, {
                  method: 'POST',
                  body: formData
              });
  
              if (!response.ok) {
                  throw new Error("Server error, please try again.");
              }
                
              const result = await response.json();
            console.log('--------2--------'); 
            console.log(result);
              if (result.has_queued) {
                  let tryCount = 0;
                  while (tryCount < 15) {
                     
                      await new Promise(resolve => setTimeout(resolve, 20000));
                      tryCount++;
                      const jobResult = await fetch(`${mockupApiURL}/api/webhook/generate/mockup/job/bulk/status/${result.template}`);
                      if (!jobResult.ok) {
                          const jobError = await jobResult.json().catch(() => null);
                          throw new Error(jobError?.message || "Mockup generation failed!");
                      }  
                      const jobRecord = await jobResult.json();
                    console.log(jobRecord);
                      if (jobRecord.remaining != 0) continue;
  
                      if (jobRecord.remaining === 0) {
                          if (jobRecord.failed != 0) {
                              throw new Error(jobRecord.message || "Mockup generation failed!");
                          }
                          const records = jobRecord.records;
                          // console.log(records);
                          setconfig(records);
                          updatefrontend();
                        break;
                      }
                  }
                
              }
          } catch (error) {
              console.error("Error:", error);
          }
      }
//------------------------------------


function setconfig(records){
  
  var cnt=0;

 for (const key in records) {
   cnt++;
    if (records.hasOwnProperty(key)) {
     const data = records[key];
      console.log("Record:", key);
      console.log("Processed URL:", data.processed_url); 
      if (Array.isArray(data.images)) {
        let imageHTML = '';
        data.images.forEach((imgUrl, index) => {
          if(cnt == 1){
            config.signTypes.acrylic_lightbox.previews.push(imgUrl); // adding images in array
             if (data.prices && typeof data.prices === 'object') { // adding pricres in array
                Object.entries(data.prices).forEach(([size, price]) => {
                  config.signTypes.acrylic_lightbox.basePrices[size.toLowerCase()] = price;
                });
            }
            config.signTypes.acrylic_lightbox.pruducturl = data.signed;
            config.signTypes.acrylic_lightbox.processedurl = data.processed_url;
          }            
          if(cnt == 2){
            config.signTypes.metal_sign.previews.push(imgUrl); // adding images in array 
             if (data.prices && typeof data.prices === 'object') { // adding pricres in array
                Object.entries(data.prices).forEach(([size, price]) => {
                  config.signTypes.metal_sign.basePrices[size.toLowerCase()] = price;
                });
            }
             config.signTypes.metal_sign.pruducturl = data.signed;
             config.signTypes.metal_sign.processedurl = data.processed_url;
          }            
          if(cnt == 3){
            config.signTypes.acrylic_backlit.previews.push(imgUrl); // adding images in array
             if (data.prices && typeof data.prices === 'object') { // adding pricres in array
                Object.entries(data.prices).forEach(([size, price]) => {
                  config.signTypes.acrylic_backlit.basePrices[size.toLowerCase()] = price;
                });
            }
             config.signTypes.acrylic_backlit.pruducturl = data.signed;
             config.signTypes.acrylic_backlit.processedurl = data.processed_url;
          }
        });        
      }
      console.log(data); 
    }

   
 } 
// call a function here to update the preview of the studio
 
}


// State management
const state = {
    currentSignType: 'acrylic_lightbox',
    currentSize: 'small',
    selectedBackground: 0,
    uploadedLogo: null
};

// DOM Elements
const elements = {
    uploadZone: document.getElementById('upload-zone'),
    fileInput: document.getElementById('file-input'),
    filebg: document.getElementById('file-bg'),
    userbg: document.getElementById('userbg'),
    filebgthumb: document.getElementById('userbgthumb'),  
    initialUpload: document.getElementById('initial-upload'),
    processingIndicator: document.getElementById('processing-indicator'),
    studioContainer: document.getElementById('studio-container'),
    mainPreviewImg: document.getElementById('main-preview-img'),
    previewTypeLabel: document.getElementById('preview-type-label'),
    backgroundThumbnails: document.getElementById('background-thumbnails'),
    pricingTitle: document.getElementById('pricing-title'),
    progressBar: document.querySelector('.progress-bar'),
    processingMessage: document.getElementById('processing-message'),
    progressStatus: document.getElementById('progress-status')
};

// Event Listeners
document.addEventListener('DOMContentLoaded', () => {
    setupUploadHandlers();
    setupSignTypeTabs();
    setupSizeOptions();
    initializeStudio();
});

elements.filebg.addEventListener('click', function () {
  // Reset the input value to allow same file selection
  elements.filebg.value = '';
});
//---------------------------
var useruploadedbg = 0;
  elements.filebg.addEventListener('change', function(event) {
  const file = event.target.files[0];
  const allthumbs = document.querySelectorAll('#background-thumbnails .v-buttons');
  allthumbs.forEach(b => b.classList.remove('active'));
  processedImageDisplay(true);   
          
  if (file && file.type.startsWith('image/')) {
    const reader = new FileReader();
    reader.onload = function(e) {
      //console.log("======"+e.target.result);
      elements.mainPreviewImg.src = e.target.result;
      //document.getElementById('userbgthumb').src = e.target.result;
        if(useruploadedbg===0){
          useruploadedbg=1;
          config.signTypes.acrylic_lightbox.thumbs.unshift(e.target.result);
          config.signTypes.metal_sign.thumbs.unshift(e.target.result);
          config.signTypes.acrylic_backlit.thumbs.unshift(e.target.result);
          config.signTypes.acrylic_lightbox.previews.unshift(e.target.result);
          config.signTypes.metal_sign.previews.unshift(e.target.result);
          config.signTypes.acrylic_backlit.previews.unshift(e.target.result);
        } else {
          config.signTypes.acrylic_lightbox.thumbs[0] = e.target.result;
          config.signTypes.metal_sign.thumbs[0] = e.target.result;
          config.signTypes.acrylic_backlit.thumbs[0] = e.target.result;
          config.signTypes.acrylic_lightbox.previews[0] = e.target.result;
          config.signTypes.metal_sign.previews[0] = e.target.result;
          config.signTypes.acrylic_backlit.previews[0] = e.target.result;
        }
      updateBackgroundThumbnails();
    };
    reader.readAsDataURL(file);
  } else {
    alert("Please select a valid image file.");
  }
});
//------------------------

// Upload Handlers
function setupUploadHandlers() {
    elements.uploadZone.addEventListener('click', () => elements.fileInput.click());
    elements.fileInput.addEventListener('change', handleFileSelect);
    elements.filebg.addEventListener('change', handleFileBG);
    
    elements.uploadZone.addEventListener('dragover', (e) => {
        e.preventDefault();
        elements.uploadZone.classList.add('drag-active');
    });

    elements.uploadZone.addEventListener('dragleave', () => {
        elements.uploadZone.classList.remove('drag-active');
    });

    elements.uploadZone.addEventListener('drop', (e) => {
        e.preventDefault();
        elements.uploadZone.classList.remove('drag-active');
        const file = e.dataTransfer.files[0];
        if (file) handleFileUpload(file);
    });
}

function handleFileBG(e) {
    const file = e.target.files[0];
    if (file) handleFileUploadedBG(file);
}
function handleFileUploadedBG(file) {
    if (!file.type.match('image.*')) {
        alert('Please upload an image file');
        return;
    }
  
// change bg here.
  // console.log("*******"+file);
  //elements.mainPreviewImg.src = currentType.previews[state.selectedBackground]; 
}
function handleFileSelect(e) {
    const file = e.target.files[0];
    if (file) handleFileUpload(file);
}
function validateform(){
    const clientName = document.getElementById('customer-name').value.trim();
    const errorSpan = document.getElementById('customername');
  if (!clientName) {
        errorSpan.textContent = 'Please enter your name first.';
        return false;
    } else {
        errorSpan.textContent = '';  // clear error if any
    }
}
function handleFileUpload(file) {



    if (!file.type.match('image.*')) {
        alert('Please upload an image file');
        return;
    }

    state.uploadedLogo = file;
    showProcessingIndicator();
    //simulateUploadProgress();
}

// Processing Simulation
function showProcessingIndicator() {
  submitForm();
    elements.initialUpload.classList.add('d-none');
    elements.processingIndicator.classList.remove('d-none');
}

function simulateUploadProgress() {
    let progress = 0;
    const totalTime = 40000; // 10 seconds
    const steps = 100;
    const interval = totalTime / steps;
    
    const progressInterval = setInterval(() => {
        progress += 1;
        updateProgress(progress);        
        // if (progress >= 100) {
          // clearInterval(progressInterval);
        // }
    }, interval);
}

function updatefrontend(){            
      setTimeout(() => {
          elements.processingIndicator.classList.add('d-none');
          elements.studioContainer.classList.remove('d-none');
          updateStudioView();
      }, 500); 
}
function updateProgress(progress) {
    elements.progressBar.style.width = `${progress}%`;
    
    // Update loading message based on progress
    const messageIndex = Math.min(
        Math.floor((progress / 100) * config.loadingMessages.length),
        config.loadingMessages.length - 1
    );
    elements.processingMessage.textContent = config.loadingMessages[messageIndex];
    
    elements.progressStatus.textContent = progress < 100 ? 
        'Please wait while we prepare your customization experience...' : 
        'Studio ready! Let\'s create your perfect signage.';
}

// Studio Initialization and Updates
function initializeStudio() {
    updateMainPreview();
    updateBackgroundThumbnails();
    updatePricingPanel();
}

function processedImageDisplay(display){
  if(display){
    document.getElementById('logo-draggable').classList.remove('d-none');  
  }
  else{
    document.getElementById('logo-draggable').classList.add('d-none');  
  }
}

function setupSignTypeTabs() {
    const tabs = document.querySelectorAll('#sign-type-tabs .nav-link');
  var currentprocessedimg;
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            processedImageDisplay(false);
          
            state.currentSignType = tab.dataset.type;
          if(config.signTypes[state.currentSignType].processedurl){
             currentprocessedimg = config.signTypes[state.currentSignType].processedurl;
            // console.log("-----------"+currentprocessedimg);            
            document.getElementById("logo-draggable").src = currentprocessedimg;     
          }                
          
            state.selectedBackground = 0;
            updateStudioView();
        });
    });
}

function setupSizeOptions() {
    const sizeButtons = document.querySelectorAll('.size-options .v-buttons');
    sizeButtons.forEach(button => {
        button.addEventListener('click', () => {
            sizeButtons.forEach(b => b.classList.remove('active'));
            button.classList.add('active');
            state.currentSize = button.dataset.size;
            updatePricingPanel();
        });
    });
}

function updateStudioView() {
    updateMainPreview();
    updateBackgroundThumbnails();
    updatePricingPanel();
}

function updateMainPreview() {
    const currentType = config.signTypes[state.currentSignType];
    elements.mainPreviewImg.src = currentType.previews[state.selectedBackground];
    // elements.previewTypeLabel.textContent = currentType.label;
}

function updateBackgroundThumbnails() {
    const currentType = config.signTypes[state.currentSignType];
    elements.backgroundThumbnails.innerHTML = `<h5 class="mb-3">Background Options</h5>`; 
    
    //static div 
    currentType.thumbs.forEach((preview, index) => {
        const thumbnail = document.createElement('div');
        thumbnail.className = `v-buttons mb-3 ${index === state.selectedBackground ? 'active' : ''}`;
        thumbnail.innerHTML = `
            <img src="${preview}" 
                alt="Background option ${index + 1}" 
                class="img-fluid rounded"
                style="width: 100%; aspect-ratio: 16/9; object-fit: cover">
        `;
        thumbnail.addEventListener('click', () => {
            state.selectedBackground = index;
            updateStudioView();
            processedImageDisplay(false);
          
        });
        elements.backgroundThumbnails.appendChild(thumbnail);
    });
}

function updatePricingPanel() {
    const currentType = config.signTypes[state.currentSignType];
    elements.pricingTitle.textContent = currentType.label;
    
    const priceElements = document.querySelectorAll('.size-options .v-buttons');
    priceElements.forEach(element => {
        const size = element.dataset.size;
        const priceElement = element.querySelector('.v-price');
        priceElement.textContent = `$${currentType.basePrices[size]}`;
    });
}

async function buyNow() {
    console.log("Button clicked!");

     const createLoader = document.getElementById("creating-loader");
     toggleLoader(createLoader, true);

    try {
        // Get the active variant title from the active button
        const activeButton = document.querySelector('.size-options .v-buttons.active');
        if (!activeButton) {
            throw new Error("No active variant selected!");
        }
        const selectedVtitle = activeButton.getAttribute('data-size');
       // const selectedVtitle = 'small';
        console.log("Selected Variant Title:", selectedVtitle);

        const currentType = config.signTypes[state.currentSignType];
        productURL = currentType.pruducturl;
        // productURL = "https://designs.quicksignage.com/api/webhook/create/bulk/product/25632?signature=7de5c1c49c54acb14a623f320923bc6c2fdace3b547cbde2ad4e48fe955517d0";
        console.log(productURL);
        // Fetch product data from the product URL
        const productData = await fetchProductData(productURL);
        let selectedVid = null;

        if (productData && productData.variants) {
            console.log("Number of Variants:", productData.variants.length);      

            // Loop through variants to find the matching size
            for (let i = 0; i < productData.variants.length; i++) {
                const variant = productData.variants[i];
                console.log("Variant Size:", variant.size);

                if (selectedVtitle.toLowerCase() === variant.size.toLowerCase()) {
                    selectedVid = variant.id;
                    break;
                }
            }
        }

        if (!selectedVid) {
            throw new Error("Selected variant ID not found!");
        }

        // Construct the redirect URL with the selected variant ID
        const redirectUrl = `https://quicksignage.com/cart/clear?return_to=/cart/add?items[0][id]=${selectedVid}%26items[0][quantity]=1%26return_to=/checkout?discount=QS10OFF`;
        console.log("Redirect URL:", redirectUrl);

        // Redirect to the checkout page
        location.href = redirectUrl;
    } catch (error) {
        console.error("Something went wrong! Please try again.", error.message);
    } finally {
        //toggleLoader(createLoader, false);
    }
}

  
  function toggleLoader(loader, isVisible) {
      loader.style.display = isVisible ? "block" : "none";
  }
  
  async function fetchProductData(url) {
      try {
          const response = await fetch(url);
          const result = await response.json();
          console.log("Full API Response:", result);
  
          if (result.status !== "success") {
              throw new Error("API did not return a success status!");
          }
  
          return result;
      } catch (error) {
          throw new Error("Failed to fetch product data: " + error.message);
      }
  }

